import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Typewriter from 'typewriter-effect';
import Tilt from 'react-parallax-tilt';
import Particle from '../Particle';
import homeLogo from '../../assets/homeLogo.svg';
import myImg from '../../assets/avatar.svg';

function Home(props) {
	let english = {
		"welcome": "Welcome!",
		"heading_name": "I'm",
		"typewriter": ['Front-end Developer', 'Graphic Designer', 'Video editor'],
		"about_header1": "LET ME",
		"about_header2": "INTRODUCE",
		"about_header3": "MYSELF",
		"about_body1": "I fell in love with programming and I have at least learnt something, I think…",
		"about_body2": "My current focus is on",
		"about_body3": "Front-end developing.",
		"about_body4": "Recently, whenever possible, I develop my skills with",
		"about_body5": "Modern JavaScript Frameworks",
		"about_body6": "like",
		"about_body7": "React.js and Node.js.",
		"findme": "FIND ME ON",
		"contact1": "Feel free to",
		"contact2": "contact",
		"contact3": "with me"
	};

	let polish = {
		"welcome": "Witam!",
		"heading_name": "Jestem",
		"typewriter": ['Programista Front-end', 'Grafik', 'Montażysta filmowy'],
		"about_header1": "POZWÓL MI SIĘ",
		"about_header2": "PRZEDSTAWIĆ",
		"about_body1": "Zakochałem się w programowaniu i myślę, że trochę się nauczyłem, przynajmniej mam taką nadzieję...",
		"about_body2": "Aktualnie koncentruję się na",
		"about_body3": "programowaniu Front-end.",
		"about_body4": "Ostatnio, kiedy tylko mogę, rozwijam swoje umiejętności związane z",
		"about_body5": "Nowoczesnymi Frameworkami JavaScript",
		"about_body6": "takimi jak",
		"about_body7": "React.js i Node.js.",
		"findme": "ZNAJDŹ MNIE",
		"contact1": "Śmiało",
		"contact2": "skontaktuj się",
		"contact3": "ze mną"
	};

	let language = '';
	if (props.language === 'english') {
		language = english;
	} else {
		language = polish;
	}

	return (
		<section>
			<Container fluid className='home-section' id='home'>
				<Particle />
				<Container className='home-content'>
					<Row>
						<Col md={7} className='home-header'>
							<h1 className='heading pb-2'>
								{language.welcome}
							</h1>

							<h1 className='heading-name'>
								{language.heading_name}<strong className='main-name'> Robert Buritta</strong>
							</h1>

							<div className='heading-typewriter'>
								<Typewriter
									options={{
										strings: language.typewriter,
										autoStart: true,
										loop: true,
										delay: 200,
										deleteSpeed: 100,
									}}
								/>
							</div>
						</Col>

						<Col md={5} style={{ paddingBottom: 20 }}>
							<img src={homeLogo} alt='home pic' className='img-fluid' />
						</Col>
					</Row>
				</Container>
			</Container>
			<hr />
			<Container fluid className='home-about-section' id='about'>
				<Container>
					<Row>
						<Col md={8} className='home-about-description'>
							<h1 style={{ fontSize: '2.6em' }}>
								{language.about_header1} <span className='color2'> {language.about_header2} </span> {language.about_header3}
							</h1>
							<p className='home-about-body'>
								{language.about_body1}
								<br /><br />
								{language.about_body2} <b className='color2'>{language.about_body3}</b>
								<br /><br />
								{language.about_body4}&nbsp;
								<b className='color2'>{language.about_body5}</b> {language.about_body6}
								<b className='color2'> {language.about_body7}</b>
							</p>
						</Col>
						<Col md={4} className='myAvatar'>
							<Tilt>
								<img src={myImg} className='img-fluid' alt='avatar' />
							</Tilt>
						</Col>
					</Row>
					<Row>
						<Col md={12} className='home-about-social'>
							<h1>{language.findme}</h1>
							<p>{language.contact1} <span className='color2'>{language.contact2}</span> {language.contact3}</p>
							<ul className='home-about-social-links'>
								<li className='social-icons'>
									<a href='https://github.com/robertburitta' target='_blank' rel='noreferrer' className='icon-colour  home-social-icons'>
										<i className='fab fa-github'></i>
									</a>
								</li>
								<li className='social-icons'>
									<a href='https://bitbucket.org/rezuss' target='_blank' rel='noreferrer' className='icon-colour  home-social-icons'>
										<i className='fab fa-bitbucket'></i>
									</a>
								</li>
								<li className='social-icons'>
									<a href='https://www.linkedin.com/in/robert-buritta-313681187' target='_blank' rel='noreferrer' className='icon-colour  home-social-icons'>
										<i className='fab fa-linkedin-in'></i>
									</a>
								</li>
							</ul>
						</Col>
					</Row>
				</Container>
			</Container>
		</section>
	);
}

export default Home;
